module.exports = __webpack_public_path__ + "static/media/5.49056662.jpg";